import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { RxIf } from '@rx-angular/template/if';

@Component({
  selector: 'lib-search-box',
  standalone: true,
  template: `
    <div class="search-box">
      <input 
        #searchInput
        type="search"
        class="search-input"
        [value]="value"
        (input)="onInput($event)"
        placeholder="Hledat..."
      />
    </div>
  `,
  styles: [`
    .search-box {
      display: flex;
      align-items: center;
    }
    .search-input {
      flex: 1;
      font-size: 1.5em;
      border-radius: 1em;
      padding: 0.3em 1em;
      max-width: calc(100vw - 1.5em);
      border: solid 0px transparent;

      box-shadow: 0 0 0.3em 0.2em rgba(0, 0, 0, 0.3) inset;
    }

    .search-input:focus,
    .search-input:focus-visible {
      border: solid 0px transparent;
      outline: none;
    }
    .reset-button {
      background: none;
      border: none;
      font-size: 1.2em;
      cursor: pointer;
    }
  `],
  imports: [RxIf]
})
export class LibSearchBoxComponent {

  @ViewChild('searchInput') inputEl!: ElementRef<HTMLInputElement>;
  @Input() value = '';

  // @Input()
  // set searchOpen(open: boolean) {
  //   if (open) queueMicrotask(() => this.focus());
  // }

  @Output() valueChange = new EventEmitter<string>();

  onInput(event: Event) {
    const newValue = (event.target as HTMLInputElement).value;
    this.valueChange.emit(newValue);
  }

  focus() {
    queueMicrotask(() => this.inputEl.nativeElement.focus());
  }

  // onReset() {
  //   this.valueChange.emit('');
  // }
}
